import { NetworkService } from "./network-service";

const API_BASE_URL = process.env.REACT_APP_API_EXECUTION_ADDRESS;

const handleTemplateError = (endpoint, error)=>{
    console.error(`Errore durante l'operazione su ${endpoint}: `, error);
}

export const TemplateService = {
    getAllTemplates:(callback, errorCallback)=>{
        const url = `${API_BASE_URL}/api/templates/`;
        NetworkService.get(url,(data)=>{
            callback(data)
        }, (error)=>{
            handleTemplateError("elenco dei template", error);
            if(errorCallback){
                errorCallback(error);
            }
        });
    },

    postTemplate: (formData, callback,errorCallback)=>{
        const url = `${API_BASE_URL}/api/templates/`;
        NetworkService.postMultiPart(url, formData, callback, (error)=>{
            handleTemplateError(`creazione del template`, error);
            if (errorCallback) {
                errorCallback(error);
            }
        });
    },

    updateTemplate: (templateId, payload, callback, errorCallback)=>{
        const url = `${API_BASE_URL}/api/templates/${templateId}/`
        NetworkService.put(url,payload, callback, (error)=>{
            handleTemplateError(`aggiornamento del template con ID ${templateId}`, error)
            if(errorCallback){
                errorCallback(error);
            }
        })
    },

    getTemplate:(templateId, callback, errorCallback)=>{
        const url = `${API_BASE_URL}/api/templates/${templateId}/`
        NetworkService.get(url, callback, (error)=>{
            if(errorCallback){
                errorCallback(error);
            }
        });
    },

    deleteTemplate: (templateId, callback, errorCallback)=>{
        const url = `${API_BASE_URL}/api/templates/${templateId}/`
        NetworkService.delete(url, callback, (error)=>{
            handleTemplateError(`eliminazione del template con ID ${templateId}`, error);
            if (errorCallback) {
                errorCallback(error);
            }
        });
    },

    downloadTemplate: (templateId) => {
        const url = `${API_BASE_URL}/api/templates/${templateId}/download/`;
        return url;
    },

    getFolderStructure:(templateId, callback, errorCallback)=>{
        const url = `${API_BASE_URL}/api/templates/${templateId}/folder_structure/`
        NetworkService.get(url, callback, (error)=>{
            if(errorCallback){
                errorCallback(error);
            }
        });
    },

    getFile: (templateId,filePath, callback, errorCallback)=>{
        const encodedFilePath = encodeURIComponent(filePath);
        const queryParams = [['path', encodedFilePath]]; 
        const url = `${API_BASE_URL}/api/templates/${templateId}/folder_structure/file/`
            NetworkService.get(url, callback, (error)=>{
                if(errorCallback){
                    errorCallback(error);
                }
            },
            queryParams
        );
        
        
    },
}